import { Injectable } from '@angular/core';
import { Router, NavigationEnd, Event } from '@angular/router';
import { filter } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class RouterService {

  private urlLast: string | null = null;
  private urlCurrent: string | null = null;
  private country: string | null = null;


  constructor(private router: Router) {

    this.router.events.pipe(
      filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {

      if (typeof window !== 'undefined' && window.sessionStorage) {
        if (this.urlCurrent != null) {
          sessionStorage.setItem('urlLast', this.urlCurrent);
        }
      }
      this.urlCurrent = event.urlAfterRedirects;

    });
  }


  getUrlLast() {
    if (typeof window !== 'undefined' && window.sessionStorage) {
      this.urlLast = sessionStorage.getItem('urlLast');
    }
    return this.urlLast;
  }

  getUrlCurrent() {
    return this.urlLast;
  }


  setCountry(country: string) {
    this.country = country;
  }

  getCountry(): string {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const countryMap: Record<string, string> = {
      'America/Mexico_City': 'MX',
      'Europe/Madrid': 'ES',
      'America/Bogota': 'CO',  

    };
    const country = countryMap[timeZone] || 'MX'; 

    return this.country || country;
  }
}
